import { render, staticRenderFns } from "./orderDetial.vue?vue&type=template&id=07752161&scoped=true&"
import script from "./orderDetial.vue?vue&type=script&lang=js&"
export * from "./orderDetial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07752161",
  null
  
)

export default component.exports